import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const certificationApiUrl = `${baseApiUrl}/api/Certification`;

export async function getCertifications() {
  return await httpRequest(fetchCertifications.bind(this));
}

async function fetchCertifications() {
  let config = getHttpHeaders();
  return await axios.get(`${certificationApiUrl}`, config);
}

export async function addCertification(newCertification) {
  return await httpRequest(postCertification.bind(this, newCertification));
}

async function postCertification(newCertification) {
  let config = getHttpHeaders();
  return await axios.post(`${certificationApiUrl}`, newCertification, config);
}

export async function updateCertification(updatedCertification) {
  return await httpRequest(putCertification.bind(this, updatedCertification));
}

async function putCertification(updatedCertification) {
  let config = getHttpHeaders();
  return await axios.put(
    `${certificationApiUrl}`,
    { ...updatedCertification },
    config
  );
}

export async function deleteCertification(id) {
  return await httpRequest(fetchDeleteCertification.bind(this, id));
}

async function fetchDeleteCertification(id) {
  let config = getHttpHeaders();
  return await axios.delete(`${certificationApiUrl}/${id}`, config);
}

export async function getUserCertifications(params) {
  return await httpRequest(fetchUserCertifications.bind(this, params));
}

async function fetchUserCertifications(params) {
  let config = getHttpHeaders();
  return await axios.get(`${certificationApiUrl}/GetUserCertifications`, {
    ...config,
    params: params,
  });
}

export async function addUserCertification(newUserCertification) {
  return await httpRequest(
    postUserCertification.bind(this, newUserCertification)
  );
}

async function postUserCertification(newUserCertification) {
  let config = getHttpHeaders();
  return await axios.post(
    `${certificationApiUrl}/AddUserCertification`,
    newUserCertification,
    config
  );
}

export async function deleteUserCertification(id) {
  return await httpRequest(fetchDeleteUserCertification.bind(this, id));
}

async function fetchDeleteUserCertification(id) {
  let config = getHttpHeaders();
  return await axios.delete(
    `${certificationApiUrl}/DeleteUserCertification/${id}`,
    config
  );
}

export async function getCategoryCourseList() {
  return await httpRequest(fetchCategoryCourseList.bind(this));
}

async function fetchCategoryCourseList() {
  let config = getHttpHeaders();
  return await axios.get(
    `${certificationApiUrl}/GetCategoryCourseList`,
    config
  );
}

export async function getCourseTypeList(input) {
  return await httpRequest(fetchCourseTypeList.bind(this, input));
}

async function fetchCourseTypeList(input) {
  let config = getHttpHeaders();
  return await axios.get(
    `${certificationApiUrl}/GetCourseTypeList?categoryCourseId=${input.categoryCourseId}`,
    config
  );
}

export async function getCourseTypeSubList(input) {
  return await httpRequest(fetchCourseTypeSubList.bind(this, input));
}

async function fetchCourseTypeSubList(input) {
  let config = getHttpHeaders();
  return await axios.get(
    `${certificationApiUrl}/GetCourseTypeSubList?courseTypeId=${input.courseTypeId}`,
    config
  );
}
